import React, { useState, useEffect } from 'react';
import { observer } from "mobx-react"
import store from './Stores/SurveyStore';
import * as DbSurvey from "../Surveys/DbSurvey";
import * as DcSurvey from "../Surveys/DcSurvey";
import { Templates } from './Templates/Templates'
import SurveyContentContainer from './SurveyContentContainer';
import SurveySection from './SurveySection'
import SurveyPage from './SurveyPage';
import { SurveyTypeURL } from "../Enums/constants"; 
import { pageNameDisplayOverride } from "../helpers";

export const PrintPage = observer(() => {
    const [PagesToRender, setPagesToRender] = useState([]);
    const [allowPrint, setAllowPrint] = useState(false);
    const [printQueued, setPrintQueued] = useState(false);

    function AvailableJSXPages() {
        const pageMapDC = {
            "Plan info": <DcSurvey.PlanInfo raw />,
            "Options": <DcSurvey.Options raw />,
            "Td&Balanced": <DcSurvey.TdBalanced raw />,
            "Admin costs": <DcSurvey.AdminCosts raw />,
            "Admin services": <DcSurvey.AdminServices raw />,
            "Plan design": <DcSurvey.PlanDesign raw/>,
            "Fiduciary": <DcSurvey.Fiduciary raw />,
            "Employer stock": <DcSurvey.EmplStock raw/>,
            "Results": <DcSurvey.Results raw />,
        };

        const pageMapDB = {
            "Plan info": <DbSurvey.PlanInfo raw />,
            "Assets": <DbSurvey.Assets raw />,
            "Benchmarks": <DbSurvey.Benchmarks raw />,
            "Expenses": <DbSurvey.Expenses raw />,
            "Liability": <DbSurvey.Liability raw />,
            "Ltd partnerships": <DbSurvey.LtdPartnerships raw />,
            "Templates": <Templates />,
            "Results": <DbSurvey.Results raw />,
        }

        let toReturn = [];
        let mapToUse = null;

        if (store.surveyTypeUrl === SurveyTypeURL.DB) {
            mapToUse = pageMapDB;
        }
        else if (store.surveyTypeUrl === SurveyTypeURL.DC) {
            mapToUse = pageMapDC;
        }
        else {
            return [];
        }
        store?.availPageTitles?.forEach((elem) => {
            if (mapToUse[elem] && elem !== "Templates") {
                toReturn.push(<div style={{ display: "flex" }} key={elem} id={elem}>{mapToUse[elem]}</div>);
            }
        });

        return toReturn;

    }

    const PrintSelectList = observer(() => {
        let options = [];
        let onChangeList = (e) => {
            store.printSettings[e.target.value] = !store.printSettings[e.target.value];
            setAllowPrint(false);
        };
        AvailableJSXPages().forEach((elem) => {
            let eKey = elem.key;
            store.printSettings[eKey] = (typeof (store.printSettings[eKey]) !== "boolean") ? true : store.printSettings[eKey];
            options.push(<div><input type="checkbox" label={eKey} value={eKey} checked={store.printSettings[eKey]} style={{ all: "revert" }} onClick={(e) => { onChangeList(e) }} /><span>{pageNameDisplayOverride(eKey)}</span></div >);

        });
        return options;

    });

    // Two things done upon rerender:
    // If a print is requested [printQueued], print upon rerendering
    // If the page is resized, make a fake div that matches the size of the "fixed" page header to displace content
    useEffect(() => {
        /* The intention is to only print if the page has been rerendered but this only kind of works */
        /* A rerender of the page doesn't always mean all printed pages are finished rendering, so an extra delay is added */
        if (printQueued === true) {
            const delay = (delayMS) => {
                return new Promise(resolve => setTimeout(resolve, delayMS));
            }
            let extraDelay = async () => {
                await delay(1500);
                setPrintQueued(false);
                window.print();
            }
            extraDelay();

        }
        const handleResize2 = () => {
            /* On resize, compare to navbar as the navbar height may change between desktop/mobile */
            let navBarDiv = document.querySelector("#printHeader");
            let navbarSpacer = document.querySelector("#printSpacer");

            let actualNavHeight = Math.max(navBarDiv.clientHeight, navBarDiv.clientHeight);
            navbarSpacer.style.height = `${actualNavHeight}px`;
        }
        handleResize2();
        window.addEventListener("resize2", handleResize2, { passive: true });
        return () => window.removeEventListener("resize", handleResize2);
    });

    return <>
        <SurveyPage>
            <SurveySection>
                <div id="printSpacer" style={{width:"100%"}}>
                </div>

                <div id="printHeader" style={{ position: "fixed", width: "88%", backgroundColor: "#fff", marginTop:"-1%", paddingTop:"1%", paddingBottom:"10px"}}>
                    <h3 className="sectionTitle">Print Your Survey</h3>
                    <hr/>
                    <div style={{ width: "50%", float: "left" }}>
                        <div style={{ float: "left", width: "auto" }}>
                            <PrintSelectList />
                        </div>
                        <div style={{ float: "right", width: "50%" }}>
                            <button type="button" className="btn btn-add-row" id="printButton" onClick={async () => { await setPagesToRender(AvailableJSXPages().filter((elem) => { return store.printSettings[elem.key] })); setPrintQueued(true); }}>Print Selection</button>
                        </div>

                    </div>
                </div>

                <br />
                <div style={{ width: "fit-content", height: "fit-content", display: "grid" }}>
                    <div style={{ width: "fit-content", height: "fit-content", zIndex: "-1" }} readOnly><SurveyContentContainer><fieldset disabled={true}>{PagesToRender}</fieldset></SurveyContentContainer></div>
                </div>
            </SurveySection>
        </SurveyPage>
    </>;
});

export default PrintPage;